module.exports = __webpack_public_path__ + "img/login_back_3.697b29a1.svg";